import { roundPrice } from '../../../utils/roundPrice';

export enum DataTestId {
  priceContainer = 'pricing-module',
  priceCurrent = 'display-price',
  pricePast = 'original-price',
  priceSavings = 'price-off',
}

type PricingModuleProps = {
  className?: string;
  pricing: {
    displayPrice: number;
    percentOff: number;
    fixedAmountOff: number;
    rrp: number;
  };
};

export const PricingModule = ({
  className,
  pricing: { fixedAmountOff, percentOff, displayPrice, rrp },
}: PricingModuleProps) => {
  const isDiscounted = percentOff || fixedAmountOff || null;
  const isPercentOff = percentOff && percentOff > 0;

  return (
    <div className={className} data-testid={DataTestId.priceContainer}>
      {isDiscounted ? (
        <div className="font-inter text-neutral text-neutral flex flex-col items-baseline gap-1 whitespace-nowrap whitespace-nowrap rounded">
          <div className="flex flex-row items-baseline gap-1">
            <Price data-testid={DataTestId.priceCurrent}>{roundPrice(displayPrice)}</Price>
            <span className="text-neutral-faded line-through" data-testid={DataTestId.pricePast}>
              {roundPrice(rrp)}
            </span>
          </div>
          <span
            className="text-tones-positive-700 text-sm font-semibold leading-none"
            data-testid={DataTestId.priceSavings}
          >
            You save {isPercentOff ? `${percentOff.toFixed(0)}%` : `£${fixedAmountOff.toFixed(0)}`}
          </span>
        </div>
      ) : (
        <Price data-testid={DataTestId.priceCurrent}>{roundPrice(displayPrice)}</Price>
      )}
    </div>
  );
};

const Price = ({ children, ...rest }) => (
  <span className="font-inter text-neutral-strong text-2xl font-bold leading-none" {...rest}>
    {children}
  </span>
);
